import { useLocalSearchParams } from 'expo-router';
import PersonProfile from '@/screens/PersonProfile';

export default function PersonProfileRoute() {
  const { personId } = useLocalSearchParams<{ personId: string }>();
  return <PersonProfile key={personId} personId={personId} />;
}
